export default __webpack_public_path__ + "static/media/launchpad_lock.acbfb8d2.png";